<div class="d-flex flex-wrap" [ngClass]="{ 'overlay-mode': isOverlayMode }">
  <!-- Show main price only if NOT in SHOW_FROM_PRICE_ONLY mode or if in admin mode or if no formattedFromPrice exists or if no actual variants exist -->
  <ng-container
    *ngIf="
      isAdminOrderCaptureUpdate ||
      variantPriceDisplay !== 'SHOW_FROM_PRICE_ONLY' ||
      (variantPriceDisplay === 'SHOW_FROM_PRICE_ONLY' &&
        (!menuItem.formattedFromPrice ||
          !menuItem.variants ||
          menuItem.variants.length === 0))
    "
  >
    <div
      class="price d-inline-block font-size-primary"
      [ngClass]="{ 'font-weight-bold': !isAdminOrderCaptureUpdate }"
      *ngIf="!menuItem.discount || !menuItem.discountType; else discountedView"
    >
      <span
        *ngIf="menuItem.priceDescription"
        class="mr-1 font-size-primary theme-color-subtitle-3"
      >
        {{ menuItem.priceDescription }}
      </span>
      <span *ngIf="menuItem.price > 0" class="theme-color-subtitle-3">
        {{ menuItem.price | formatPrice: locale : currency : currencySymbol }}
        <span
          *ngIf="menuItem.consumption && menuItem.consumption != menuItem.price"
        >
          <app-icon icon="fa-solid fa-arrow-right"></app-icon>
          {{
            menuItem.consumption
              | formatPrice: locale : currency : currencySymbol
          }}
        </span>
        <span
          *ngIf="
            isAdminOrderCaptureUpdate &&
            ((menuItem.variants && menuItem.variants.length > 0) ||
              menuItem.isExpandable)
          "
          class="ml-1 theme-color-subtitle-3"
          >...</span
        >
      </span>
      <span
        class="mr-1 font-size-primary theme-color-subtitle-3"
        *ngIf="
          menuItem.price == 0 &&
          menuItem.variants &&
          menuItem.variants.length > 0 &&
          !menuItem.priceDescription
        "
      >
        {{ 'public.global.standard' | translate }}
      </span>
    </div>
    <ng-template #discountedView>
      <div
        class="price font-size-primary"
        *ngIf="
          menuItem.discount && menuItem.discountType == 'MONETARY';
          else discountedPercentileView
        "
      >
        <span
          *ngIf="menuItem.priceDescription"
          class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3"
        >
          {{ menuItem.priceDescription }}
        </span>
        <div class="d-inline-block">
          <span
            class="strikethrough mr-1 font-size-primary"
            *ngIf="!isAdminOrderCaptureUpdate"
          >
            {{
              menuItem.price | formatPrice: locale : currency : currencySymbol
            }}</span
          >
          <span
            class="ml-1 font-size-primary theme-color-subtitle-3"
            [ngClass]="{
              'font-weight-bold': !isAdminOrderCaptureUpdate,
              'discounted-price': !isAdminOrderCaptureUpdate,
            }"
          >
            {{
              menuItem.price - menuItem.discount
                | formatPrice: locale : currency : currencySymbol
            }}
          </span>
          <span
            *ngIf="
              isAdminOrderCaptureUpdate &&
              ((menuItem.variants && menuItem.variants.length > 0) ||
                menuItem.isExpandable)
            "
            class="ml-1 theme-color-subtitle-3"
            >...</span
          >
          <i class="fa-solid fa-tag ml-2 mr-1 discounted-price fs-12"></i>
          <span
            *ngIf="
              menuItem.consumption && menuItem.consumption != menuItem.price
            "
          >
            <app-icon icon="fa-solid fa-arrow-right"></app-icon>
            <span
              class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
            >
              {{
                menuItem.consumption
                  | formatPrice: locale : currency : currencySymbol
              }}
            </span>
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template #discountedPercentileView>
      <div class="price font-size-primary">
        <span
          *ngIf="menuItem.priceDescription"
          class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3"
        >
          {{ menuItem.priceDescription }}
        </span>
        <div class="d-inline-block">
          <span
            class="strikethrough mr-1 font-size-primary"
            *ngIf="!isAdminOrderCaptureUpdate"
          >
            {{
              menuItem.price | formatPrice: locale : currency : currencySymbol
            }}
          </span>
          <span
            class="ml-1 font-size-primary theme-color-subtitle-3"
            [ngClass]="{ 'font-weight-bold': !isAdminOrderCaptureUpdate }"
          >
            {{
              (menuItem.price * (100 - menuItem.discount)) / 100
                | formatPrice: locale : currency : currencySymbol
            }}
          </span>
          <span
            *ngIf="
              isAdminOrderCaptureUpdate &&
              ((menuItem.variants && menuItem.variants.length > 0) ||
                menuItem.isExpandable)
            "
            class="ml-1 theme-color-subtitle-3"
            >...</span
          >
          <i class="fa-solid fa-tag ml-2 mr-1 discounted-price fs-12"></i>
          <span
            class="discounted-price font-size-primary font-weight-bold"
            *ngIf="!isAdminOrderCaptureUpdate"
          >
            - {{ menuItem.discount | number }}%
          </span>
          <span
            *ngIf="
              menuItem.consumption && menuItem.consumption != menuItem.price
            "
          >
            <app-icon icon="fa-solid fa-arrow-right"></app-icon>
            <span
              class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
            >
              {{
                menuItem.consumption
                  | formatPrice: locale : currency : currencySymbol
              }}
            </span>
          </span>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="!isAdminOrderCaptureUpdate">
    <!-- SHOW_FROM_PRICE_ONLY Mode - Only show "From" when actual price variants exist -->
    <ng-container
      *ngIf="
        variantPriceDisplay === 'SHOW_FROM_PRICE_ONLY' &&
        menuItem.formattedFromPrice &&
        menuItem.variants &&
        menuItem.variants.length > 0
      "
    >
      <span class="font-size-primary font-weight-bold theme-color-subtitle-3">
        {{ 'public.global.from' | translate }} {{ menuItem.formattedFromPrice }}
      </span>
    </ng-container>

    <!-- SHOW_ALL_VARIANTS Mode (default) -->
    <ng-container *ngIf="variantPriceDisplay !== 'SHOW_FROM_PRICE_ONLY'">
      <span
        class="variant font-size-primary"
        *ngFor="let variant of menuItem.variants"
      >
        <span
          *ngIf="variant.priceDescription"
          class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3"
        >
          {{ variant.priceDescription }}
        </span>
        <span
          class="font-weight-bold theme-color-subtitle-3"
          [ngClass]="{ 'd-none': variant.price == 0 }"
          *ngIf="
            !variant.discount || !variant.discountType;
            else variantDiscountedView
          "
        >
          {{ variant.price | formatPrice: locale : currency : currencySymbol }}
          <span
            *ngIf="variant.consumption && variant.consumption != variant.price"
          >
            <i class="fa-solid fa-arrow-right" style="color: #000000"></i>
            {{
              variant.consumption
                | formatPrice: locale : currency : currencySymbol
            }}
          </span>
        </span>
        <ng-template #variantDiscountedView>
          <span
            class="font-size-primary"
            *ngIf="
              variant.discount && variant.discountType == 'MONETARY';
              else variantPercentileView
            "
          >
            <span>
              <span class="strikethrough mr-1 font-size-primary">
                {{
                  variant.price
                    | formatPrice: locale : currency : currencySymbol
                }}
              </span>
              <span
                class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
              >
                {{
                  variant.price - variant.discount
                    | formatPrice: locale : currency : currencySymbol
                }}
              </span>
              <i class="fa-solid fa-tag ml-2 discounted-price fs-12"></i>
              <span
                *ngIf="
                  variant.consumption && variant.consumption != variant.price
                "
              >
                <app-icon icon="fa-solid fa-arrow-right"></app-icon>
                <span
                  class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
                >
                  {{
                    variant.consumption
                      | formatPrice: locale : currency : currencySymbol
                  }}
                </span>
              </span>
            </span>
          </span>
        </ng-template>
        <ng-template #variantPercentileView>
          <span class="font-size-primary">
            <span>
              <span class="strikethrough mr-1 font-size-primary">
                {{
                  variant.price
                    | formatPrice: locale : currency : currencySymbol
                }}
              </span>
              <span
                class="ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
              >
                {{
                  (variant.price * (100 - variant.discount)) / 100
                    | formatPrice: locale : currency : currencySymbol
                }}
              </span>
              <i class="fa-solid fa-tag ml-2 discounted-price fs-12"></i>
              <span class="discounted-price ml-2 font-weight-bold">
                - {{ variant.discount | number }}%
              </span>
              <span
                *ngIf="
                  variant.consumption && variant.consumption != variant.price
                "
              >
                <app-icon icon="fa-solid fa-arrow-right"></app-icon>
                <span
                  class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3"
                >
                  {{
                    variant.consumption
                      | formatPrice: locale : currency : currencySymbol
                  }}
                </span>
              </span>
            </span>
          </span>
        </ng-template>
      </span>
    </ng-container>
  </ng-container>
</div>
